import { render, staticRenderFns } from "./DropdownQuestion.vue?vue&type=template&id=a0d62d6c&scoped=true&"
import script from "./DropdownQuestion.vue?vue&type=script&lang=js&"
export * from "./DropdownQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d62d6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
